import { Box, Button, Grid2 } from "@mui/material";
import React, { useState, useEffect } from "react";
import SideBar from "../SideBar/SideBar";
import { useTheme, useMediaQuery } from "@mui/material";
import './Pricing.css'
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import Modal from '@mui/material/Modal';
import Stack from "@mui/material/Stack";
import Typography from '@mui/material/Typography';
import TextField from "@mui/material/TextField";
import DeleteIcon from '@mui/icons-material/Delete';
import { ToastContainer, toast } from 'react-toastify';
import { Link, useNavigate } from "react-router-dom";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import PropTypes from "prop-types";
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Collapse from '@mui/material/Collapse';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';

// Collapse
const ExpandMore = styled((props) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
})(({ theme }) => ({
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
    variants: [
        {
            props: ({ expand }) => !expand,
            style: {
                transform: 'rotate(0deg)',
            },
        },
        {
            props: ({ expand }) => !!expand,
            style: {
                transform: 'rotate(180deg)',
            },
        },
    ],
}));

// tap
function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

const drawerWidth = 300;
const Pricing = () => {
    const notify = () => toast.success('Setup Completed');
    const remove = () => toast.success('Deleted successfully');

    const theme = useTheme();
    const isLgUp = useMediaQuery(theme.breakpoints.up("sm"));

    const [pop, setPop] = useState(false);
    const handlePopOpen = () => setPop(true);
    const handlePopClose = () => setPop(false);

    // tab
    const [tab, setTab] = useState(0);
    const handleTabChange = (event, newValue) => {
        setTab(newValue);
    };
    // Accordion
    const [expanded, setExpanded] = React.useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };
    // Collapse
    const [expandedCollapse, setExpandedCollapse] = React.useState(false);

    const handleExpandCollapseClick = () => {
        setExpandedCollapse(!expandedCollapse);
    };

    const navigate = useNavigate();
    return (
        <div className="Pricing">
            {/* <Box sx={{ display: isLgUp ? "flex" : "block", marginTop: "20px" }}>
                <SideBar />

                <Box
                    component="main"
                    sx={{
                        flexGrow: 1,
                        p: isLgUp ? 5 : 1,
                        width: { sm: `calc(100% - ${drawerWidth}px)` },
                        marginTop: isLgUp ? "0px" : "80px",
                    }}
                > */}
                    <Grid2 container spacing={2}>
                        <Grid2
                            item
                            size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                            className="mb-20"
                        >
                            <div className="tab-common">
                                <Box>
                                    <Tabs
                                        value={tab}
                                        onChange={handleTabChange}
                                        aria-label="basic tabs example"
                                        className="Pricing-month-tab"
                                    >
                                        <Tab label="Monthly" {...a11yProps(0)} />
                                        <Tab label="Yearly" {...a11yProps(1)} />
                                        {/* <Tab label="Item Three" {...a11yProps(2)} /> */}
                                    </Tabs>
                                </Box>
                                <CustomTabPanel value={tab} index={0}>
                                    <div className="Pricing-month-card-main">
                                        <Grid2 container spacing={2}>
                                            <Grid2 item size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }} className="Pricing-month-card mb-20">
                                                <Typography id="modal-modal-title" variant="h6" component="h5" sx={{ fontSize: '22px' }}>
                                                    Trial
                                                </Typography>
                                                <Typography id="modal-modal-title" variant="p" component="p" sx={{ fontSize: '12px', paddingTop: '10px' }}>
                                                    Ideal for businesses just getting started
                                                </Typography>
                                                <Typography id="modal-modal-title" variant="p" component="p" sx={{ fontSize: '14px', paddingTop: '20px' }}>
                                                    This plan includes 250 Minutes per month
                                                </Typography>
                                                <Typography id="modal-modal-title" variant="h2" component="h2" sx={{ paddingTop: '30px', fontWeight: '700' }}>
                                                    $50/<span>month</span>
                                                </Typography>
                                                <div>
                                                <Stack direction="row" spacing={0.5} className="mt-10" sx={{ paddingTop: '20px' }}>
                                                    <CheckBoxIcon />    <Typography id="modal-modal-title" variant="p" component="p" sx={{ textAlign: 'start', fontSize: '15px' }} >
                                                        This plan includes 250 Minutes per month
                                                    </Typography>
                                                </Stack>
                                                <Stack direction="row" spacing={0.5} className="mt-10">
                                                    <CheckBoxIcon />    <Typography id="modal-modal-title" variant="p" component="p" sx={{ textAlign: 'start', fontSize: '15px' }}>
                                                        Up to 10 Human Associates
                                                    </Typography>
                                                </Stack>
                                                <Stack direction="row" spacing={0.5} className="mt-10">
                                                    <CheckBoxIcon />    <Typography id="modal-modal-title" variant="p" component="p" sx={{ textAlign: 'start', fontSize: '15px' }}>
                                                        Regular Support: TAT ~24 hours
                                                    </Typography>
                                                </Stack>
                                                </div>
                                                <div className="bg-clr1 mt-50 mb-20">
                                                    <Button>Subscribe</Button>
                                                </div>
                                            </Grid2>
                                            <Grid2 item size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }} className="Pricing-month-card Pricing-month-card2 mb-20">
                                                <div className="Pricing-month-card-off">
                                                    <Typography id="modal-modal-title" variant="p" component="p" sx={{ fontSize: '10px', padding: '7px 10px' }}>
                                                        15% off
                                                    </Typography>
                                                </div>
                                                <Typography id="modal-modal-title" variant="h6" component="h5" sx={{ fontSize: '22px' }}>
                                                    Starter
                                                </Typography>
                                                <Typography id="modal-modal-title" variant="p" component="p" sx={{ fontSize: '12px', paddingTop: '10px' }}>
                                                    Suitable for small businesses
                                                </Typography>
                                                <Typography id="modal-modal-title" variant="p" component="p" sx={{ fontSize: '14px', paddingTop: '20px' }}>
                                                    This plan includes 1000 Minutes per month
                                                </Typography>
                                                <Typography id="modal-modal-title" variant="p" component="p" sx={{ fontSize: '12px', paddingTop: '20px', textDecoration: 'line-through' }}>
                                                    $200/ month
                                                </Typography>
                                                <Typography id="modal-modal-title" variant="h2" component="h2" sx={{ lineHeight: '50px', fontWeight: '700' }}>
                                                    $170/<span>month</span>
                                                </Typography>
                                                <div>
                                                <Stack direction="row" spacing={0.5} className="mt-10" sx={{ paddingTop: '20px' }}>
                                                    <CheckBoxIcon />    <Typography id="modal-modal-title" variant="p" component="p" sx={{ textAlign: 'start', fontSize: '15px' }} >
                                                        1000 Minutes per month
                                                    </Typography>
                                                </Stack>
                                                <Stack direction="row" spacing={0.5} className="mt-10">
                                                    <CheckBoxIcon />    <Typography id="modal-modal-title" variant="p" component="p" sx={{ textAlign: 'start', fontSize: '15px' }}>
                                                        Up to 10 Human Associates
                                                    </Typography>
                                                </Stack>
                                                <Stack direction="row" spacing={0.5} className="mt-10">
                                                    <CheckBoxIcon />    <Typography id="modal-modal-title" variant="p" component="p" sx={{ textAlign: 'start', fontSize: '15px' }}>
                                                        Regular Support: TAT ~24 hours
                                                    </Typography>
                                                </Stack>
                                                </div>
                                                <div className="bg-clr1 mt-50 mb-20">
                                                    <Button>Subscribe</Button>
                                                </div>
                                            </Grid2>
                                            <Grid2 item size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }} className="Pricing-month-card mb-20">
                                                <div className="Pricing-month-card-off">
                                                    <Typography id="modal-modal-title" variant="p" component="p" sx={{ fontSize: '10px', padding: '7px 10px', color: '#fff' }}>
                                                        MOST POPULAR
                                                    </Typography>
                                                </div>
                                                <Typography id="modal-modal-title" variant="h6" component="h5" sx={{ fontSize: '22px' }}>
                                                    Growth
                                                </Typography>
                                                <Typography id="modal-modal-title" variant="p" component="p" sx={{ fontSize: '12px', paddingTop: '10px' }}>
                                                    Ideal for businesses just getting started
                                                </Typography>
                                                <Typography id="modal-modal-title" variant="p" component="p" sx={{ fontSize: '14px', paddingTop: '20px' }}>
                                                    This plan includes 250 Minutes per month
                                                </Typography>
                                                <Typography id="modal-modal-title" variant="p" component="p" sx={{ fontSize: '12px', paddingTop: '20px', textDecoration: 'line-through' }}>
                                                    $200/ month
                                                </Typography>
                                                <Typography id="modal-modal-title" variant="h2" component="h2" sx={{ lineHeight: '50px', fontWeight: '700' }}>
                                                    $500/<span>month</span>
                                                </Typography>
                                                <div>
                                                <Stack direction="row" spacing={0.5} className="mt-10" sx={{ paddingTop: '20px' }}>
                                                    <CheckBoxIcon />    <Typography id="modal-modal-title" variant="p" component="p" sx={{ textAlign: 'start', fontSize: '15px' }} >
                                                        2500 Minutes per month
                                                    </Typography>
                                                </Stack>
                                                <Stack direction="row" spacing={0.5} className="mt-10">
                                                    <CheckBoxIcon />    <Typography id="modal-modal-title" variant="p" component="p" sx={{ textAlign: 'start', fontSize: '15px' }}>
                                                        Up to 10 Human Associates
                                                    </Typography>
                                                </Stack>
                                                <Stack direction="row" spacing={0.5} className="mt-10">
                                                    <CheckBoxIcon />    <Typography id="modal-modal-title" variant="p" component="p" sx={{ textAlign: 'start', fontSize: '15px' }}>
                                                        Premium Support: TAT ~10 hours
                                                    </Typography>
                                                </Stack>
                                                </div>
                                                <div className="bg-clr mt-50 mb-20">
                                                    <Button>Subscribe</Button>
                                                </div>
                                            </Grid2>

                                        </Grid2>
                                    </div>
                                </CustomTabPanel>
                                <CustomTabPanel value={tab} index={1}>
                                    <div className="Pricing-month-card-main">
                                        <Grid2 container spacing={2}>
                                            <Grid2 item size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }} className="Pricing-month-card mb-20">
                                                <Typography id="modal-modal-title" variant="h6" component="h5" sx={{ fontSize: '22px' }}>
                                                    Trial
                                                </Typography>
                                                <Typography id="modal-modal-title" variant="p" component="p" sx={{ fontSize: '12px', paddingTop: '10px' }}>
                                                    Ideal for businesses just getting started
                                                </Typography>
                                                <Typography id="modal-modal-title" variant="p" component="p" sx={{ fontSize: '14px', paddingTop: '20px' }}>
                                                    This plan includes 250 Minutes per year
                                                </Typography>
                                                <Typography id="modal-modal-title" variant="h2" component="h2" sx={{ paddingTop: '30px', fontWeight: '700' }}>
                                                    $150/<span>year</span>
                                                </Typography>
                                                <div>
                                                <Stack direction="row" spacing={0.5} className="mt-10" sx={{ paddingTop: '20px'}}>
                                                    <CheckBoxIcon />    <Typography id="modal-modal-title" variant="p" component="p" sx={{ textAlign: 'start', fontSize: '15px' }} >
                                                        This plan includes 250 Minutes per year
                                                    </Typography>
                                                </Stack>
                                                <Stack direction="row" spacing={0.5} className="mt-10">
                                                    <CheckBoxIcon />    <Typography id="modal-modal-title" variant="p" component="p" sx={{ textAlign: 'start', fontSize: '15px' }}>
                                                        Up to 10 Human Associates
                                                    </Typography>
                                                </Stack>
                                                <Stack direction="row" spacing={0.5} className="mt-10">
                                                    <CheckBoxIcon />    <Typography id="modal-modal-title" variant="p" component="p" sx={{ textAlign: 'start', fontSize: '15px' }}>
                                                        Regular Support: TAT ~24 hours
                                                    </Typography>
                                                </Stack>
                                                </div>

                                                <div className="bg-clr1 mt-50 mb-20">
                                                    <Button>Subscribe</Button>
                                                </div>
                                            </Grid2>
                                            <Grid2 item size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }} className="Pricing-month-card Pricing-month-card2 mb-20">
                                                <div className="Pricing-month-card-off">
                                                    <Typography id="modal-modal-title" variant="p" component="p" sx={{ fontSize: '10px', padding: '7px 10px' }}>
                                                        15% off
                                                    </Typography>
                                                </div>
                                                <Typography id="modal-modal-title" variant="h6" component="h5" sx={{ fontSize: '22px' }}>
                                                    Starter
                                                </Typography>
                                                <Typography id="modal-modal-title" variant="p" component="p" sx={{ fontSize: '12px', paddingTop: '10px' }}>
                                                    Suitable for small businesses
                                                </Typography>
                                                <Typography id="modal-modal-title" variant="p" component="p" sx={{ fontSize: '14px', paddingTop: '20px' }}>
                                                    This plan includes 1000 Minutes per year
                                                </Typography>
                                                <Typography id="modal-modal-title" variant="p" component="p" sx={{ fontSize: '12px', paddingTop: '20px', textDecoration: 'line-through' }}>
                                                    $2500/ year
                                                </Typography>
                                                <Typography id="modal-modal-title" variant="h2" component="h2" sx={{ lineHeight: '50px', fontWeight: '700' }}>
                                                    $1700/<span>year</span>
                                                </Typography>
                                                <div>
                                                <Stack direction="row" spacing={0.5} className="mt-10" sx={{ paddingTop: '20px' }}>
                                                    <CheckBoxIcon />    <Typography id="modal-modal-title" variant="p" component="p" sx={{ textAlign: 'start', fontSize: '15px' }} >
                                                        1000 Minutes per year
                                                    </Typography>
                                                </Stack>
                                                <Stack direction="row" spacing={0.5} className="mt-10">
                                                    <CheckBoxIcon />    <Typography id="modal-modal-title" variant="p" component="p" sx={{ textAlign: 'start', fontSize: '15px' }}>
                                                        Up to 10 Human Associates
                                                    </Typography>
                                                </Stack>
                                                <Stack direction="row" spacing={0.5} className="mt-10">
                                                    <CheckBoxIcon />    <Typography id="modal-modal-title" variant="p" component="p" sx={{ textAlign: 'start', fontSize: '15px' }}>
                                                        Regular Support: TAT ~24 hours
                                                    </Typography>
                                                </Stack>
                                                </div>
                                                <div className="bg-clr1 mt-50 mb-20">
                                                    <Button>Subscribe</Button>
                                                </div>
                                            </Grid2>
                                            <Grid2 item size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }} className="Pricing-month-card mb-20">
                                                <div className="Pricing-month-card-off">
                                                    <Typography id="modal-modal-title" variant="p" component="p" sx={{ fontSize: '10px', padding: '7px 10px', color: '#fff' }}>
                                                        MOST POPULAR
                                                    </Typography>
                                                </div>
                                                <Typography id="modal-modal-title" variant="h6" component="h5" sx={{ fontSize: '22px' }}>
                                                    Growth
                                                </Typography>
                                                <Typography id="modal-modal-title" variant="p" component="p" sx={{ fontSize: '12px', paddingTop: '10px' }}>
                                                    Ideal for businesses just getting started
                                                </Typography>
                                                <Typography id="modal-modal-title" variant="p" component="p" sx={{ fontSize: '14px', paddingTop: '20px' }}>
                                                    This plan includes 250 Minutes per year
                                                </Typography>
                                                <Typography id="modal-modal-title" variant="p" component="p" sx={{ fontSize: '12px', paddingTop: '20px', textDecoration: 'line-through' }}>
                                                    $2001/ year
                                                </Typography>
                                                <Typography id="modal-modal-title" variant="h2" component="h2" sx={{ lineHeight: '50px', fontWeight: '700' }}>
                                                    $5000/<span>year</span>
                                                </Typography>
                                                <div>
                                                <Stack direction="row" spacing={0.5} className="mt-10" sx={{ paddingTop: '20px' }}>
                                                    <CheckBoxIcon />    <Typography id="modal-modal-title" variant="p" component="p" sx={{ textAlign: 'start', fontSize: '15px' }} >
                                                        2500 Minutes per year
                                                    </Typography>
                                                </Stack>
                                                <Stack direction="row" spacing={0.5} className="mt-10">
                                                    <CheckBoxIcon />    <Typography id="modal-modal-title" variant="p" component="p" sx={{ textAlign: 'start', fontSize: '15px' }}>
                                                        Up to 10 Human Associates
                                                    </Typography>
                                                </Stack>
                                                <Stack direction="row" spacing={0.5} className="mt-10">
                                                    <CheckBoxIcon />    <Typography id="modal-modal-title" variant="p" component="p" sx={{ textAlign: 'start', fontSize: '15px' }}>
                                                        Premium Support: TAT ~10 hours
                                                    </Typography>
                                                </Stack>
                                                </div>
                                                <div className="bg-clr mt-50 mb-20">
                                                    <Button>Subscribe</Button>
                                                </div>
                                            </Grid2>

                                        </Grid2>
                                    </div>
                                </CustomTabPanel>
                                {/* <CustomTabPanel value={tab} index={2}>
                    Item Three
                  </CustomTabPanel> */}
                            </div>
                        </Grid2>
                        <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} className="mb-20" >
                            <Typography id="modal-modal-title" variant="h2" component="h2" sx={{ fontSize: '22px', fontWeight: '600' }}>
                                ADD ONS
                            </Typography>
                        </Grid2>
                        <Grid2 item size={{ xs: 12, sm: 12, md: 5, lg: 5, xl: 5 }} className="Pricing-month-card mb-20" >
                            <div className="Pricing-month-card-off">
                                <Typography id="modal-modal-title" variant="p" component="p" sx={{ fontSize: '10px', padding: '7px 10px', color: '#fff' }}>
                                    Extra Minutes
                                </Typography>
                            </div>
                            <Typography id="modal-modal-title" variant="h6" component="h5" sx={{ fontSize: '22px' }}>
                                Growth
                            </Typography>
                            <Typography id="modal-modal-title" variant="h2" component="h2" sx={{ paddingTop: '30px', fontWeight: '700' }}>
                                $150/<span>year</span>
                            </Typography>
                            <div className="Offer-price-button-three">
                                <Typography id="modal-modal-title" variant="p" component="p" sx={{ fontSize: '12px', padding: '7px 10px' }}>
                                    For
                                </Typography>
                                <Button>
                                    <span>
                                        <Button
                                            class="btn btn-outline-primary"
                                            type="button"
                                        // onClick={decNum}
                                        >
                                            -
                                        </Button>
                                    </span>
                                    <input
                                        type="text"
                                        class="form-control"
                                    //   value={num}
                                    //   onChange={handleChange}
                                    />
                                    <span>
                                        <Button
                                            class="btn btn-outline-primary"
                                            type="button"
                                        // onClick={incNum}
                                        >
                                            +
                                        </Button>
                                    </span>
                                </Button>
                                <Typography id="modal-modal-title" variant="p" component="p" sx={{ fontSize: '12px', padding: '7px 10px' }}>
                                    x250 Minutes
                                </Typography>
                            </div>
                            <div className="bg-clr1 mt-10 mb-10">
                                <Button>Purchase Now</Button>
                            </div>
                            <Stack direction="row" spacing={0.5} className="mt-10">
                                <CheckBoxIcon />    <Typography id="modal-modal-title" variant="p" component="p" sx={{ textAlign: 'start', fontSize: '15px' }}>
                                    Purchase additional minutes to keep campaigns going. Each pack adds 250 minutes to your quota.
                                </Typography>
                            </Stack>

                        </Grid2>
                        <Grid2 item size={{ xs: 12, sm: 12, md: 7, lg: 7, xl: 7 }} className="Pricing-month-card mb-20">
                            <Typography id="modal-modal-title" variant="h6" component="h5" sx={{ fontSize: '22px' }}>
                                Enterprise
                            </Typography>
                            <Typography id="modal-modal-title" variant="p" component="p" sx={{ fontSize: '12px', paddingTop: '10px' }}>
                                Those who want full scale access
                            </Typography>
                            <Typography id="modal-modal-title" variant="p" component="p" sx={{ fontSize: '14px', paddingTop: '20px', maxWidth: '300px', margin: '0 auto' }}>
                                Please Fill the form by clicking below, and We will soon be contacting you.
                            </Typography>
                            <Typography id="modal-modal-title" variant="h2" component="h2" sx={{ fontWeight: '700', fontSize: '30px', paddingTop: '20px' }}>
                                Talk to Us
                            </Typography>
                            <div className="bg-clr1 mt-30 mb-10">
                                <Button onClick={handlePopOpen}>Contact us</Button>
                            </div>
                            {/* modal-popup Contact Us */}
                            <div className="modal-popup">
                                <Modal
                                    open={pop}
                                    onClose={handlePopClose}
                                    aria-labelledby="modal-modal-title"
                                    aria-describedby="modal-modal-description"
                                >
                                    <Box className="common-modal-box">
                                    <div className="close-icons-popup">
                      <HighlightOffIcon  onClick={handlePopClose}/>
                    </div>
                                        <div className="">
                                            <Typography id="modal-modal-title" variant="h6" component="h2">
                                                Contact Us
                                            </Typography>
                                            <Grid2 container spacing={1} sx={{ display: "flex", mt: "20px", justifyContent: "center", }}>

                                                <Grid2 item size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }} sx={{ justifyContent: "center" }}>
                                                    <div className="input-common">
                                                        <label>First Name *</label>
                                                        <TextField fullWidth id="fullWidth" placeholder="Enter First Name" />
                                                    </div>
                                                </Grid2>
                                                <Grid2 item size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }} sx={{ justifyContent: "center" }}>
                                                    <div className="input-common">
                                                        <label>Last Name *</label>
                                                        <TextField fullWidth id="fullWidth" placeholder="Enter Last Name" />
                                                    </div>
                                                </Grid2>
                                                <Grid2 item size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} sx={{ justifyContent: "center" }}>
                                                    <div className="input-common">
                                                        <label>Email *</label>
                                                        <TextField fullWidth id="fullWidth" placeholder="@gmail.com" />
                                                    </div>
                                                </Grid2>
                                                <Grid2 item size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} sx={{ justifyContent: "center" }}>
                                                    <div className="input-common">
                                                        <label>Customer Number *</label>
                                                        <TextField fullWidth id="fullWidth" placeholder="Customer Number *" />
                                                    </div>
                                                </Grid2>
                                                <Grid2 item size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} sx={{ justifyContent: "center" }}>
                                                    <div className="input-common">
                                                        <label>Description (optional)</label>
                                                        <TextField multiline rows={5} fullWidth id="fullWidth" placeholder="Enter campaign name" />

                                                    </div>
                                                </Grid2>
                                                <Grid2 item size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} sx={{ justifyContent: "center" }}>
                                                    <Typography id="modal-modal-title" variant="p" component="p" sx={{ fontSize: '14px', paddingTop: '20px', paddingBottom: '30px' }}>
                                                        Kindly fill this form and We will get back to you as soon as possible.
                                                    </Typography>
                                                </Grid2>
                                            </Grid2>
                                        </div>

                                        <Stack direction="row" spacing={2} sx={{ justifyContent: "center" }}>
                                            <div className="border-graient mt-10">
                                                <Button onClick={handlePopClose}>Cancel</Button>
                                            </div>
                                            <div className="border-graient mt-10">
                                                <Button onClick={notify}>Save</Button>

                                            </div>
                                        </Stack>
                                    </Box>
                                </Modal>
                            </div>
                        </Grid2>

                        <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} className="mt-20" >
                            <Typography id="modal-modal-title" variant="h2" component="h2" sx={{ fontSize: '22px', fontWeight: '600' }}>
                                FAQ’S
                            </Typography>
                        </Grid2>
                        <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} className="mb-20" sx={{ height: '100%' }} >
                            <div className="PlaceOrder-cart-Accordion">
                                <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                    >
                                        <Typography component="span">
                                            What is the difference between an agent and an assistant ?
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography>
                                            An assistant is your voice bot where as an agent is human to whom you can transfer the call in between
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>

                                <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel2bh-content"
                                        id="panel2bh-header"
                                    >
                                        <Typography component="span">
                                            Do you offer a free trial? How does that work ?
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography>Yes we offer Free Trial For 7 days. We provide 30 voice minutes which you can consume during that 7 day free trial. After that those minutes will be expired.
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>

                                <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel3bh-content"
                                        id="panel3bh-header"
                                    >
                                        <Typography component="span">
                                            Can I upgrade or downgrade/switch plans at any time ?
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography>Yes, You can upgrade or downgrade your plans at any time. Basically at the time of renewal you can choose which plan you want to renew with.
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>

                                <Accordion expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel4bh-content"
                                        id="panel4bh-header"
                                    >
                                        <Typography component="span">
                                            Does my free trial limit my access to features ?
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography>No, There is no such restrictions on any features as of now. However they are quotas associated with some features.
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>

                                <Accordion expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel5bh-content"
                                        id="panel4bh-header"
                                    >
                                        <Typography component="span">
                                            What payment methods do you accept ?
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography>As of now, we only accept Credit Cards for subscriptions and other purchases.
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                                <Collapse in={expandedCollapse} timeout="auto" unmountOnExit>
                                <Accordion expanded={expanded === 'panel6'} onChange={handleChange('panel6')}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel6bh-content"
                                        id="panel6bh-header"
                                    >
                                        <Typography component="span">
                                            What payment methods do you accept ?
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography>As of now, we only accept Credit Cards for subscriptions and other purchases.
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>

                                <Accordion expanded={expanded === 'panel7'} onChange={handleChange('panel7')}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel6bh-content"
                                        id="panel7bh-header"
                                    >
                                        <Typography component="span">
                                            What payment methods do you accept ?
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography>As of now, we only accept Credit Cards for subscriptions and other purchases.
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>

                                <Accordion expanded={expanded === 'panel8'} onChange={handleChange('panel8')}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel8bh-content"
                                        id="panel8bh-header"
                                    >
                                        <Typography component="span">
                                            What payment methods do you accept ?
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography>As of now, we only accept Credit Cards for subscriptions and other purchases.
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>

                                <Accordion expanded={expanded === 'panel9'} onChange={handleChange('panel9')}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel9bh-content"
                                        id="panel9bh-header"
                                    >
                                        <Typography component="span">
                                            What payment methods do you accept ?
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography>As of now, we only accept Credit Cards for subscriptions and other purchases.
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                                </Collapse>
                              <div className="PlaceOrder-cart-view mt-20" onClick={handleExpandCollapseClick}>
                                <div className="PlaceOrder-cart-view-color">
                              <Typography id="modal-modal-title" variant="p" component="p" sx={{ fontSize: '18px', fontWeight: '600',color:'#fff' }}>
                                    See {expandedCollapse ? "less":"more"}
                                </Typography>
                              <ExpandMore
                                    expand={expandedCollapse}
                                    aria-expanded={expandedCollapse}
                                    aria-label="show more"
                                    sx={{padding:'0px'}}
                                >
                                    <ExpandMoreIcon />
                                </ExpandMore>
                                </div>
                              </div>
                              
                            </div>
                        </Grid2>
                    </Grid2>
                {/* </Box>
            </Box> */}
        </div>
    )
}

export default Pricing